import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function LeadForm({ id, source = "landing", dark = false }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/leads", { email, name, source });
      navigate(`/grazie${data.name ? `?nome=${encodeURIComponent(data.name)}` : ""}`);
    } catch (err) {
      toast.error(err.response?.status === 422 ? "Controlla l'indirizzo email" : "Qualcosa è andato storto, riprova");
      setLoading(false);
    }
  };

  const field = `w-full h-14 px-5 rounded-full text-base outline-none border focus:border-[#C05746] ${
    dark ? "bg-white/10 border-white/20 text-white placeholder:text-white/50" : "bg-white border-[#E5E1D8] placeholder:text-[#5A625C]/60"
  }`;

  return (
    <form onSubmit={submit} className="w-full max-w-md space-y-3" data-testid={`${id}-form`}>
      <input
        data-testid={`${id}-name-input`}
        className={field}
        placeholder="Il tuo nome"
        value={name}
        maxLength={60}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        data-testid={`${id}-email-input`}
        className={field}
        type="email"
        required
        placeholder="La tua email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`${id}-submit-button`}
        className="btn-terra w-full h-14 rounded-full font-semibold text-base flex items-center justify-center gap-2 disabled:opacity-70"
      >
        {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Voglio la guida gratuita <ArrowRight className="w-4 h-4" /></>}
      </button>
      <p className={`text-xs ${dark ? "text-white/60" : "text-[#5A625C]"}`}>
        Gratis. Niente spam: 3 email utili in 7 giorni, poi decidi tu.
      </p>
    </form>
  );
}
